import { useInView } from "react-intersection-observer"
import Chart, { TChartProps } from "../Chart"

export default function ChartLoader(props: TChartProps) {
  const { inView, ref } = useInView({
    triggerOnce: true,
    threshold: 0.1, // Trigger when 10% of the element is visible
    rootMargin: "50px", // Trigger 50px before the element comes into view
  })

  const content = inView ? (
    <Chart {...props} />
  ) : (
    <div className="flex items-center justify-center h-64 text-gray-500">
      Loading chart...
    </div>
  )

  return (
    <div className={`${props.className}`} ref={ref}>
      {content}
    </div>
  )
}
